import React from "react";
import { PropTypes } from "prop-types";
const FXCMHandleOnclick = ({onClick, children}) => {
    return(<span style={{cursor:'pointer'}} onClick={onClick}>{children}</span>) // NOSONAR
}
FXCMHandleOnclick.propTypes = {
    onClick: PropTypes.func,
    children: PropTypes.string,
  };
export default FXCMHandleOnclick;